import {customAttribute, autoinject} from "aurelia-framework";
import "jquery";

@autoinject
@customAttribute('blur-on-enter')
export class BlurOnEnter
{
    private element: Element;
    private onEnter: EventListener;

    constructor(element:Element)
    {
        this.element = element;
        this.onEnter = (event:KeyboardEvent) => {
            if (event.keyCode === 13) {
                event.stopPropagation();
                $(element).blur();
                return false;
            }
            return true;
        };
    }

    attached()
    {
        this.element.addEventListener("keyup", this.onEnter);
    }

    detached()
    {
        this.element.removeEventListener("keyup", this.onEnter);
    }
}